import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { Registry } from '@core/registry';
import { PrivatePlatformClient, HttpStatusCodes } from '@coveo-platform/private-platform-client';
var VITAL_FETCH_URLS = new RegExp('^.*/rest/((organizations/\\w*/license(\\?.*)?)|(organizations/\\w*)|(tokens/[\\w-]*/info))$');
var outOfService = {
    canProcess: function canProcess(param) {
        var status = param.status, url = param.url;
        var unknownNetworkError = status === 0 && navigator.onLine;
        var platformError = status === HttpStatusCodes.SERVICE_UNAVAILABLE;
        var platformUnreachable = status === HttpStatusCodes.GATEWAY_TIMEOUT;
        var platformVitalFetchError = status === HttpStatusCodes.INTERNAL_SERVER_ERROR && VITAL_FETCH_URLS.test(url);
        return unknownNetworkError || platformError || platformUnreachable || platformVitalFetchError;
    },
    process: function process(response) {
        return _async_to_generator(function() {
            var event, error, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = new Event('helpers:show-out-of-service', {
                            bubbles: true
                        });
                        document.dispatchEvent(event);
                        window['admin'].vent.trigger('helpers:show-out-of-service');
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        throw error;
                }
            });
        })();
    }
};
var offline = {
    canProcess: function canProcess(param) {
        var status = param.status;
        return status === 0 && !navigator.onLine;
    },
    process: function process(response) {
        return _async_to_generator(function() {
            var event, error, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = new Event('connection:offline', {
                            bubbles: true
                        });
                        document.dispatchEvent(event);
                        window['admin'].vent.trigger('connection:offline');
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        throw error;
                }
            });
        })();
    }
};
var unauthorized = {
    canProcess: function canProcess(param) {
        var status = param.status;
        return status === HttpStatusCodes.UNAUTHORIZED;
    },
    process: function process(response) {
        return _async_to_generator(function() {
            var event, error, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = new Event('helper:authorize', {
                            bubbles: true
                        });
                        document.dispatchEvent(event);
                        window['admin'].vent.trigger('helper:authorize');
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        throw error;
                }
            });
        })();
    }
};
var allOtherErrors = {
    canProcess: function canProcess() {
        return true;
    },
    process: function process(response) {
        return _async_to_generator(function() {
            var _ref, error, _tmp, hasNoToken, tokenIsInvalid, event, handleError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        hasNoToken = (error === null || error === void 0 ? void 0 : error.errorCode) === 'TOKEN_NOT_FOUND';
                        tokenIsInvalid = [
                            'InvalidToken',
                            'ExpiredToken'
                        ].includes((_ref = error === null || error === void 0 ? void 0 : error.type) !== null && _ref !== void 0 ? _ref : null);
                        if (hasNoToken || tokenIsInvalid) {
                            event = new Event('helper:authorize', {
                                bubbles: true
                            });
                            document.dispatchEvent(event);
                            window['admin'].vent.trigger('helper:authorize');
                        } else {
                            handleError = Registry.get('error_handler');
                            handleError(error);
                        }
                        throw error;
                }
            });
        })();
    }
};
export var ResponseHandlers = [
    PrivatePlatformClient.Handlers.noContent,
    PrivatePlatformClient.Handlers.success,
    offline,
    outOfService,
    unauthorized,
    allOtherErrors
];

//# sourceMappingURL=ResponseHandlers.js.map